import * as http from './base'
import $store from '../store'

const getMenus = params => http.fetch('/menus', params)

const addMenus = params => http.post('/menu/create', params)

const updateMenu = params => http.post('/menu/update', params)

const delMenus = id => http.del('/menu/delete', {
  id
})

export {
  getMenus,
  addMenus,
  updateMenu,
  delMenus
}



// WEBPACK FOOTER //
// ./src/http/menu.js